export class Analytics {
  static trackEvent(event: string) {
    window.dataLayer?.push({ event });
  }

  /** Log in button click */
  static logInClick(): void {
    Analytics.trackEvent('login_nav_cta_click');
  }

  /** Sign up button click */
  static signUpClick(): void {
    Analytics.trackEvent('signup_nav_cta_click');
  }

  /** Get started hero click */
  static getStartedHeroClick(): void {
    Analytics.trackEvent('get_started_hero_cta_click');
  }

  /** Generate a website button click */
  static generateWebsiteClick(): void {
    Analytics.trackEvent('body_cta_click');
  }

  /** Sign up banner button click */
  static signUpBannerButtonClick(): void {
    Analytics.trackEvent('signup_banner_cta_click');
  }

  /** View plans hero click */
  static viewPlansHeroClick(): void {
    Analytics.trackEvent('view_plans_hero_cta_click');
  }

  /** Contact us submit button click */
  static contactUsSubmit(): void {
    Analytics.trackEvent('submit_form_cta_click');
  }
}
